<div class="confirm-dialog">
  <h2 class="confirm-title">{{ data.title }}</h2>
  <p class="confirm-message">{{ data.message }}</p>
  <div class="confirm-actions">
    <button
      *ngIf="data.cancelText"
      mat-stroked-button
      class="cancel-button"
      (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    <button
      mat-raised-button
      [class.danger-button]="data.isDanger"
      [class.primary-button]="!data.isDanger"
      (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </div>
</div>
